import React, { Component, ReactElement } from 'react';
import PropTypes from 'prop-types';
import { Select } from '../../../atoms/Select';
import { getTextColor } from 'style';
import breakpoints from 'theme/material/breakpoints';

const getSelectStyles = () => ({
  borderWidth: 0,
  boxShadow: 'none',
  paddingLeft: 0,
  borderStyle: 'none',
  border: 'none',
  backgroundColor: 'transparent',
  textAlign: 'right',
  paddingRight: 25,
  fontSize: 15,
  lineHeight: '23px',
  letterSpacing: -0.5,
  fontWeight: 600,
  ...getTextColor().DARK_2,
  [breakpoints.down(768.05)]: {
    fontSize: 13,
    fontWeight: 400,
  },

  '&:focus': {
    borderStyle: 'none',
  },
});

class SearchSort extends Component {
  render(): ReactElement {
    // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
    const { order, onChangeHandler } = this.props;

    return (
      <Select
        noSpacing
        customSelectStyle={getSelectStyles()}
        onChange={onChangeHandler}
        value={order || ''}
        id="order"
        customIconStyle={{ right: 0 }}
      >
        <option value="recent">Recent Activity</option>
        <option value="newest">Newest Members</option>
        <option value="distance">Nearest To Me</option>
      </Select>
    );
  }
}

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
SearchSort.propTypes = {
  onChangeHandler: PropTypes.func.isRequired,
};

export default SearchSort;
